import { render, staticRenderFns } from "./FacilityEditTabPeople.vue?vue&type=template&id=1c67078e&"
import script from "./FacilityEditTabPeople.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports